import { motion } from "framer-motion";
import { Quote, Award, Code2, Building2 } from "lucide-react";
import { IMAGES, FOUNDER } from "../../data/content";

const highlights = [
  { icon: Award, label: "23+ Years in IT & Enterprise Software" },
  { icon: Code2, label: "Complex, High-Scale Application Architecture" },
  { icon: Building2, label: "Founder, Rishmathi Tech Ventures" },
];

export const Founder = () => {
  return (
    <section
      id="founder"
      className="relative py-24 sm:py-32 border-t border-white/5 bg-[#0F172A]/30"
      data-testid="founder-section"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
            className="relative"
          >
            <div className="relative rounded-3xl overflow-hidden border border-white/10 max-w-md mx-auto lg:mx-0">
              <img
                src={IMAGES.founder}
                alt="Abhilash Gampa, Founder of Rishmathi Tech Ventures"
                className="w-full h-[480px] object-cover object-center"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#020617] via-transparent to-transparent" />
              <div className="absolute bottom-5 left-5">
                <div className="font-heading text-xl font-semibold text-white">
                  {FOUNDER.name}
                </div>
                <div className="text-sm text-[#06B6D4]">{FOUNDER.title}</div>
              </div>
            </div>
            <div className="absolute -bottom-6 right-3 lg:right-10 bg-[#020617]/90 backdrop-blur-xl border border-white/10 rounded-2xl px-6 py-4 glow-indigo">
              <div className="font-heading text-3xl font-bold gradient-text">
                23+
              </div>
              <div className="text-xs text-[#94A3B8]">Years of Experience</div>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
          >
            <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#06B6D4]">
              Leadership
            </span>
            <h2 className="mt-4 font-heading text-3xl sm:text-4xl font-semibold tracking-tight text-white">
              23 Years of Architectural Excellence
            </h2>

            <div className="mt-6 relative pl-6 border-l-2 border-[#6366F1]/40">
              <Quote className="absolute -left-3 -top-1 text-[#6366F1] bg-[#0F172A] rounded-full" size={20} />
              <p className="text-base text-[#94A3B8] leading-relaxed italic">
                "Great software isn't measured by lines of code—it's measured by
                the complexity it removes. Rishmathi exists to engineer
                intelligence into the systems businesses rely on every day."
              </p>
            </div>

            <p className="mt-6 text-base text-[#94A3B8] leading-relaxed">
              Abhilash Gampa, our founder, brings over two decades of hands-on
              IT leadership and deep architectural expertise in designing
              complex, mission-critical applications across enterprise
              environments. From large-scale distributed systems to secure data
              platforms, that experience is the backbone of every product
              Rishmathi ships.
            </p>
            <p className="mt-4 text-base text-[#94A3B8] leading-relaxed">
              This founding vision—pairing rigorous architecture with AI-first
              automation—is what enables us to deliver enterprise-grade software
              at a fraction of the traditional time and cost.
            </p>

            <div className="mt-8 space-y-3">
              {highlights.map((h) => (
                <div key={h.label} className="flex items-center gap-3">
                  <div className="h-9 w-9 rounded-lg bg-[#6366F1]/15 border border-white/10 flex items-center justify-center shrink-0">
                    <h.icon className="text-[#06B6D4]" size={18} />
                  </div>
                  <span className="text-sm text-white/90">{h.label}</span>
                </div>
              ))}
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
